export class ProgressConstants {
  static maxProgress = 100;
}
